
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ads-iq/real-estate",
      function () {
        return require("private-next-pages/ads-iq/real-estate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ads-iq/real-estate"])
      });
    }
  